import Indicator from '../Indicator';
import LineMarker from '../markers/LineMarker';
import BandMarker from '../markers/BandMarker';

/** Money Flow Index indicator */
export default class MoneyFlowIndexIndicator extends Indicator {
	/**
	 * Returns the default params for this type of indicator. Overrides abstract
	 * method inherited from Indicator.
	 * @returns {object} - Default parameters object
	 * @property {string} id - Indicator ID
	 * @property {string} name - Indicator name
	 * @property {string} description - Indicator description
	 * @property {object[]} inputs - Indicator inputs
	 * @property {object[]} bands - Indicator bands
	 */
	_getDefaultParams() {
		return {
			id: 'moneyflowindex',
			name: 'Money Flow Index',
			description:
				'The Money Flow Index describes the rate at which money is flowing into or out of a security. It is similar to the RSI but includes volume within the calculation in addition to price.',
			inputs: [{ name: 'period', value: 15 }],
			bands: [
				{
					labelTranslationKey: 'band.overbought',
					valHigh: 100,
					valLow: 80
				},
				{
					labelTranslationKey: 'band.oversold',
					valHigh: 20,
					valLow: 0
				}
			],
			componentSeries: [
				{ id: 'moneyflowindex' }
			]
		};
	}

	/** @return {number} Minimum range (default 0)*/
	getRangeMin() {
		return 0;
	}

	/** @return {number} Maximum range (default 100) */
	getRangeMax() {
		return 100;
	}

	/**
	 * @return {object}
	 * @property {LineMarker} line
	 * @property {BandMarker} overbought
	 * @property {BandMarker} oversold
	 */
	_getMarkers() {
		return {
			line: new LineMarker(),
			overbought: new BandMarker(this.params.bands[0], this.panel),
			oversold: new BandMarker(this.params.bands[1], this.panel)
		};
	}

	/** @param {object} data Symbol data object */
	render(data, sessionType) {
		this.markers.overbought.render(this.panel, this.params.style.overbought);
		this.markers.oversold.render(this.panel, this.params.style.oversold);
		this._renderLineMarker({
			data: data[this.params.id],
			sessionType
		});
	}
}
